export default {
      id: "Icon--photoMissing-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--photoMissing",
      toString: function () {
        return this.url;
      }
    }